GoodsWarrantyModalView = Backbone.View.extend
  el: '#goods-warranty-modal'
  scrollOffset: 0

  events:
    'click .add-protection': 'addWarranty'
    'click .details-link': 'toggleMoreDetails'
    'click .no-thanks': 'removeWarranty'
    'click .t-back-link': 'hideGoodsWarrantyModal'

  initialize: ({@model}) ->
    @$goodsWarrantyOption = $('.goods-warranty-option')
    @$touchBackLink = @$el.find('.t-back-link')

  addWarranty: ->
    @model.set 'isSelected', true
    @$touchBackLink.click() if @$touchBackLink?.length

  hideGoodsWarrantyModal: ->
    @$body ?= $('body')
    @$mainTouchPane ?= $('#global-container')

    @$mainTouchPane.show()
    @$el.hide()
    @$body.animate scrollTop: @scrollOffset, 'slow'

  removeWarranty: ->
    @model.set 'isSelected', false
    @$touchBackLink.click() if @$touchBackLink?.length

  toggleMoreDetails: ->
    @$detailsLink ?= @$el.find '.details-link'
    @$finePrint ?= @$el.find '.fine-print-messages'

    @$finePrint.toggle()
    @$detailsLink.toggle()

module.exports = GoodsWarrantyModalView
